<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__container">
        <h2>Enlace inválido</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
